<template>
    <div class="card" id="Device" style="direction: rtl">
        <div class="card-header" style="display:flex">
            <h3 class="card-title">مدیریت دستگاه ها</h3>
            <div style="flex-grow:1">

            </div>
            <CButton    color="outline-primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="[isShowAdvancedSearch=!isShowAdvancedSearch,$store.state.Devices.RequestResponse=[]]"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجوی پیشرفته </CButton>
        </div>
        <div class="card-body" style="display:flex;flex-direction:column;gap:10px">
            <CCollapse  :show="isShowAdvancedSearch"  :duration="300">
                <CCardBody style="display:flex;flex-direction:column;gap:10px">
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.FleetName" style="flex-grow: 1;" label="نام خط"/>
                        <CInput v-model="AdvancedSearch.VehicleName" style="flex-grow: 1;" label="نام خودرو"/>
                        <CInput v-model="AdvancedSearch.DriverName" style="flex-grow: 1;" label="نام راننده"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.IMEI" style="flex-grow: 1;" label="IMEI"/>
                        <CInput v-model="AdvancedSearch.DeviceID" style="flex-grow: 1;" label="شناسه دستگاه"/>
                        <CInput v-model="AdvancedSearch.Version" style="flex-grow: 1;"  label="ورژن برنامه"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <div style="flex-grow: 1;"></div>
                            <CButton v-if="$store.state.InlineLoading.Device_AdvancedSearch" disabled=""    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                                <b-spinner small></b-spinner>
                                <span class="sr-only">درحال جستجو...</span>
                                </CButton>
                            <CButton v-else    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="Device_AdvancedSearch()"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجو </CButton>
                        </div>

                </CCardBody>
            </CCollapse>
            <div class="input-group" style="direction: rtl" v-if="!isShowAdvancedSearch">
                <span class="input-group-text" style="min-width: 100px">انتخاب خط</span>
                <input class="form-control" disabled  v-model="Fleet.FleetName" type="text"   aria-describedby="basic-addon1">
                <CButton @click="DialogSelectFleet = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                &nbsp;&nbsp;
                <CButton v-if="Fleet.FleetName!==''"  color="warning" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="SelectFleet">بروز رسانی</CButton>
                <CButton v-else disabled=""  color="warning" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">بروز رسانی</CButton>
                <!-- <CButton v-if="$store.state.InlineLoading.Device_GetInfoLikeIMEI" disabled=""    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                        <b-spinner small></b-spinner>
                        <span class="sr-only">درحال جستجو...</span>
                     </CButton>
                <CButton v-else    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="DialogSearchIMEI=true"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجو </CButton> -->
            </div>
            <CDataTable
                    :hover="true"
                    :border="true"
                    :columnFilter='{}'
                    :striped="true"
                    :small="true"
                    :items="$store.state.Devices.RequestResponse"
                    :fields="fields"
                    :fixed="true"
                    ref="table"
                    @row-clicked="SelectDevice"
                    :tableFilterValue="TableFilter"
                    :clickableRows="true"
                    :items-per-page="7"
                    pagination
                    style="float: right;width: 100%;overflow: hidden"
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

            >

                <template #details="{item}">
                    <CCollapse :show="item.DeviceID===indexDeviceSelect"  :duration="500">
                        <CCardBody style="float: right;width: 100%;height:400px ;border: 1px solid silver;margin-top:0px;">
                            <div style="float: right;width: 60%;">
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">شماره شناسایی خط</span>
                                    <input class="form-control" disabled v-model="item.FleetID" type="text" style="text-align: center;" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">شماره شناسایی خودرو</span>
                                    <input class="form-control" disabled v-model="item.CurrVehicleID" type="text" style="text-align: center;" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">نوع خودرو</span>
                                    <input class="form-control" disabled v-model="item.CurrVehicleTypeID" type="text" style="text-align: center;" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">مدل خودرو</span>
                                    <input class="form-control" disabled v-model="item.CurrVehicleModel" type="text" style="text-align: center;" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">وضعیت خودرو</span>
                                    <input class="form-control" disabled v-model="item.CurrVehicleStatus" type="text" style="text-align: center;" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">شماره شناسایی راننده</span>
                                    <input class="form-control" disabled v-model="item.CurrDriverID" type="text" style="text-align: center;" >
                                </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;">وضعیت راننده</span>
                                     <input class="form-control" disabled v-model="item.CurrDriverStatus" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">کلید اتصال</span>
                                     <input class="form-control" disabled v-model="item.TCPSessionKey" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">MaxEN</span>
                                     <input class="form-control" disabled v-model="item.MaxEN" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">LLSDT</span>
                                     <input class="form-control" disabled v-model="item.LLSDT" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">زاویه خودرو</span>
                                     <input class="form-control" disabled v-model="item.LastAngle" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">پسوورد</span>
                                     <input class="form-control" disabled v-model="item.Password" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">شماره سیم کارت</span>
                                     <input class="form-control" disabled v-model="item.SIMPhoneNum" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">شارژ سیم کارت</span>
                                     <input class="form-control" disabled v-model="item.SIMCharge" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">تاریخ شارژ سیم کارت</span>
                                     <p class="form-control" v-if="item!=null"  v-text="GetDateTime(item.SIMChargeDate)"  style="text-align: center;" ></p>
                                     <p class="form-control"   v-text="'نامشخص'"  style="text-align: center;" ></p>
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">ورژن</span>
                                     <input class="form-control" disabled v-model="item.Version" type="text" style="text-align: center;" >
                                 </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">سرعت</span>
                                     <input class="form-control" disabled v-model="item.LastSpeed" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">تگ</span>
                                     <input class="form-control" disabled v-model="item.LastTag" type="text" style="text-align: center;" >
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">آخرین زمان اتصال</span>
                                     <p class="form-control" disabled v-text="GetDateTime(item.LastConnectStartTime)" type="text" style="text-align: center;direction: ltr;" ></p>
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">آخرین زمان قطع اتصال</span>
                                     <p class="form-control" disabled v-text="GetDateTime(item.LastConnectEndTime)" type="text" style="text-align: center;direction: ltr;" ></p>
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">سنسور دما 1</span>
                                     <p class="form-control" disabled v-text="item.LastTemp1" type="text" style="text-align: center;direction: ltr;" ></p>
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">صورتحساب</span>
                                     <p class="form-control" disabled v-text="item.Bill" type="text" style="text-align: center;direction: ltr;" ></p>
                                 </div>
                                 <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                     <span class="input-group-text" style="min-width: 120px;">بیشتر</span>
                                     <p class="form-control" disabled v-text="item.LastExtra" type="text" style="text-align: center;direction: ltr;" ></p>
                                 </div>
                            </div>
                            <div style="float:left;width:40%;height: 90%;border:2px solid silver;border-radius: 7px;overflow: hidden">
                                <l-map
                                        ref="myMap"
                                        v-if="item.DeviceID===indexDeviceSelect"
                                        :zoom="zoom"
                                        :center="center"
                                        style="float:left;width:100%;height: 100%;"
                                >
                                    <l-tile-layer
                                            :url="url"
                                            :attribution="attribution"
                                    />
                                    <l-wms-tile-layer
                                        :key="wmsLayer.name"
                                        :base-url="wmsLayer.url"
                                        :layers="wmsLayer.layers"
                                        :visible="wmsLayer.visible"
                                        :name="wmsLayer.name"
                                        :attribution="wmsLayer.attribution"
                                        :transparent="true"
                                        format="image/png"
                                        layer-type="base">
                                    </l-wms-tile-layer>

                                    <l-marker ref="marker5"    :lat-lng="[item.LastLat,item.LastLon]">
                                        <l-icon
                                                :icon-size="[32, 37]"
                                                :icon-url="getIcon(item)"
                                        />

                                    </l-marker>



                                </l-map><!-- -->
                            </div>

                            </CCardBody>
                    </CCollapse>
                </template>
                <template #Edit="{item}">
                    <td >
                        <CButton   color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="EditDevice(item)">ویرایش</CButton>
                        
                    </td>
                </template>
                <template #Move="{item}">
                    <td >
                        <CButton   color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="[(DialogChangeFleet=true) , (indexDeviceSelect2=item.DeviceID)]">جابجایی </CButton>
                        
                    </td>
                </template>
                <template #ConnectState="{item}">
                    <td style="align-items: center">
                        <b-form-checkbox disabled  style="width:35px;margin: 0 auto" :checked="item.ConnectState==='1'" size="lg"></b-form-checkbox>

                    </td>
                </template>
               <template #MotoState="{item}">
                    <td style="align-items: center;font-size: 16px" >
                        <b-form-checkbox disabled v-if="item.MotoState===true ||item.MotoState===false"  style="width:35px;margin: 0 auto" :checked="item.MotoState" size="lg"></b-form-checkbox>
                        <CBadge v-else color="warning"> نامشخص</CBadge>

                    </td>
                </template>
                <template #LastLon="{item}">
                    <td style="align-items: center;font-size: 16px" >
                        <span v-if="item.LastLon!=='0.0'">{{item.LastLon}}</span>
                        <CBadge v-else color="warning"> نامشخص</CBadge>

                    </td>
                </template>

            </CDataTable>
            <div style="float: left;width: 100%" v-if="TableFilter.length===0 && Devices.length>0">
                <br>
                <CBadge style="float: left;color: white;font-size: 16px" color="info" v-text="'  تعداد خودرو:   '+Devices.length"> نامشخص</CBadge>
                <br><br>
                <CBadge v-if="false" style="float: left;color: white;font-size: 16px" color="success" v-text="'                    تعداد دستگاه آنلاین:  '+NumberDeviceOnline"> نامشخص</CBadge>

            </div>
        </div>
        <div class="card-footer" style="display:flex;direction:ltr;gap:10px">
            <MPrint 
                v-if="$store.state.Devices.length>0"
                :data="$store.state.Devices.RequestResponse"
            
                label="PDF" 
                title="دستگاه ها"
                :fields="fields">
            </MPrint>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSelectFleet"
        >
            <div style="direction: rtl;text-align: right;diaply:flex;flex-direction:column">
                <CInput v-model="TextSearchFleet" placeholder="جستجو" label="نام خط"/>
                <div >
                    <select class="form-select"  size="10" v-model="indexFleet">
                        <option v-for="(fleet,index) in GetFleetsSearch($store.state.Fleets.RequestResponse,TextSearchFleet)" :value="index" v-text="fleet.FleetName" v-bind:key="index"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectFleet = false" color="danger">بستن</CButton>
                <CButton @click="SelectFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogChangeFleet"
        >
            <div style="direction: rtl;text-align: right">
                <div >
                    <CSelect label="انتخاب خط"    :options="GetFleetsOtions($store.state.AllFleets.RequestResponse)" @change="indexFleet2=$event.target.selectedIndex" >
                        
                    </CSelect>
                </div>
                <div  style="direction: rtl">
                    <CInput  v-model="FleetPassword"     label="کلمه عبور" type="text"  />
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; تغییر خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogChangeFleet = false" color="danger">بستن</CButton>
                <CButton @click="Device_MoveToFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogEditDevice"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CInput
                        label="شماره شناسایی"
                            v-model="DeviceSelect.DeviceID"
                            disabled
                        />
                </CRow>
                <CRow>
                    <CInput
                        label="پسوورد"
                            v-model="DeviceSelect.Password"
                            disabled
                        />
                </CRow>
                <CRow>
                    <CInput
                        label="سیم کارت"
                            v-model="DeviceSelect.SIMPhoneNum"
                        />
                </CRow>
                <CRow>
                    <CInput
                        label="سریال"
                            v-model="DeviceSelect.Serial"
                        />
                </CRow>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; ویرایش دستگاه </h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditDevice = false" color="warning">انصراف</CButton>
                <CButton v-if="$store.state.InlineLoading.Device_Update"  color="primary"  >
                    <b-spinner small></b-spinner>
                    <span class="sr-only">درحال به روزرسانی...</span>
                </CButton>
                <CButton v-else color="primary"  @click="UpdateDevice()" >
                    به روز رسانی
                </CButton>
                
            </template>
        </CModal>

        
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSearchIMEI"
        >
            <div style="direction: rtl;text-align: right">
                <div class="input-group" style="direction: rtl">
                    <span class="input-group-text" style="min-width: 100px">IMEI </span>
                    <input class="form-control"  v-model="TextSearchIMEI" type="text"   aria-describedby="basic-addon1">
                    
                </div>
                
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; یافتن  دستگاه </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSearchIMEI = false" color="danger">بستن</CButton>
                <CButton @click="SearchIMEI()" color="primary"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجو </CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { latLng } from "leaflet";
    import Constant from './../../assets/Constants'
    export default {
        name: "Devices",
        data(){
            return {
                isShowAdvancedSearch:false,
                TextSearchIMEI:'',
                DialogSearchIMEI:false,
                zoom: 13,
                LastActivePage: 1,
                center: latLng(35.708309, 51.380730),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="#">RADA Smart City</a> contributors',
                    wmsLayer: {
                    url: 'https://gis.shiraz.ir/shirazgis/gis_workspace/wms?',
                    name: 'Weather Data',
                    visible: true,
                    format: 'image/png',
                    layers: 'regionwms',
                    transparent: true,
                    attribution: 'Weather data &copy; 2012 <a href="https://mesonet.agron.iastate.edu/docs/nexrad_mosaic/">IEM Nexrad</a>',
                },
                User:null,
                Fleets: [],
                FleetsOtions: [],
                FleetPassword: "",
                LoadingDevices: false,
                Devices: [],
                DeviceSelect:{},
                indexDeviceSelect:-1,
                indexDeviceSelect2:-1,
                indexFleet:0,
                indexFleet2:0,
                Fleet:{FleetName:""},
                DialogSelectFleet:false,
                DialogEditDevice:false,
                DialogChangeFleet:false,
                TextSearchFleet:'',
                TableFilter:'',
                NumberDeviceOnline:0,
                AdvancedSearch:{
                    FleetName:'',
                    VehicleName:'',
                    DriverName:'',
                    IMEI:'',
                    DeviceID:'',
                    Version:'',
                },
                fields:[{"key":"DeviceID","label":"شماره شناسایی"},{"key":"IMEI","label":"IMEI"},{"key":"CurrVehicleName","label":"کد خودرو"},{"key":"CurrDriverName","label":"نام راننده"},{"key":"CurrVehiclePlate","label":"پلاک"},{"key":"Model","label":"مدل"},{"key":"LastLat","label":"طول جغرافیایی"},{"key":"LastLon","label":"عرض جغرافیایی"},{"key":"LastGPSReceptionTime","label":"آخرین ارسال"},{"key":"ConnectState","label":"وضعیت اتصال"},{"key":"MotoState","label":"وضعیت خودرو"},{"key":"Edit","label":"ویرایش"},{"key":"Move","label":"جایجایی"}],
            }
        },
        computed:{
            ReadDevice_MoveToFleet(){
                return this.$store.state.Device_MoveToFleet;
            },
            ReadDevice_Update(){
                return this.$store.state.ResponseUpdateDevice;
            }
        },
        watch:{
            ReadDevice_MoveToFleet(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            this.SelectFleet();
                            this.DialogChangeFleet=false;
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                        }
                        
                    }
                    
                }
            },
            ReadDevice_Update(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            this.DialogEditDevice=false;
                            this.GetDeviceByFleet(this.Fleet.FleetID);
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                        }
                        
                    }
                    
                }
            }
        },
        mounted() {
            this.url=Constant.MapUrl;
            if(this.$session.has("User")){
                this.User= this.$session.get("User");
                console.log("User-->"+this.User);
                
            }
            this.GetFleets();

        },
        methods:{
            GetFleets(){
               this.$store.commit('FleetByUser');
               this.$store.commit('Fleet_GetAll');
            },
            SelectFleet()
            {
                console.log(this.indexFleet)
                var fleets=this.GetFleetsSearch(this.$store.state.Fleets.RequestResponse,this.TextSearchFleet);
                 this.Fleet=fleets[this.indexFleet];
                // 
                // console.log(this.Fleet)
                this.DialogSelectFleet=false;
                this.GetDeviceByFleet(this.Fleet.FleetID);
            },
            GetDeviceByFleet(fleetID){
                this.$store.commit('Device_GetByFleetID',{
                    FleetID:fleetID
                });
            },
            Device_MoveToFleet(){
                var crypto = require('crypto')
                var shasum = crypto.createHash('sha1')
                shasum.update(this.FleetPassword)
                var pass=shasum.digest('hex');
                this.$store.commit('Device_MoveToFleet',{
                    DeviceID:this.indexDeviceSelect2,
                    FleetID:this.$store.state.AllFleets.RequestResponse[this.indexFleet2].FleetID,
                    DOP:pass,
                    });

               
            },
            GetDateTime(time){
               // console.log("GetDateTime");
               // console.log(time);
                if(time!=null)
                    return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
                else "نامشخص";
            },
            SelectDevice(item, index, columnname, event){
                var table=this.$refs.table;
                console.log(columnname)
                if(columnname !== "details" && columnname !== "Move" && columnname !== "Edit") {
                    if (this.indexDeviceSelect === -1) {
                        this.LastActivePage=table.page;
                        this.DeviceSelect = item;
                        this.indexDeviceSelect = item.DeviceID;
                        this.TableFilter = item.IMEI;
                        if(item.LastLat!=="0.0"){
                            this.center=latLng(item.LastLat, item.LastLon);
                            //this.$refs.myMap.mapObject.flyTo(,15,{"animate": true, "pan": {"duration": 3}});
                        }
                        
                    } else {
                        this.indexDeviceSelect = -1;
                        this.DeviceSelect = {};
                        var that=this;
                        setTimeout(function() {
                            that.TableFilter ="";
                            
                        }, 700);
                        table.page=this.LastActivePage;
                    }
                }else {
                    console.log("EXpand")
                }

            },
            getIcon(device){
                if(device.MotoState === '1'){
                    return 'images/'+device.CurrVehicleTypeID+'/1/'+(Math.floor((device.LastAngle*2)/6)+1)+'.png'
                }else {
                    return 'images/'+device.CurrVehicleTypeID+"/0/"+(Math.floor((device.LastAngle*2)/6)+1)+'.png'
                }

            },
            EditDevice(item){
                this.DeviceSelect=item;
                this.DialogEditDevice=true;
            },
            
            GetFleetsOtions(fleets){
                var options=[];
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
            },
            UpdateDevice(){
                var timeNow=Vue.moment().format('YYYY_MM_DD_HH_mm_ss');
                 this.$store.commit('Device_Update',{
                    UserID:1,
                    DeviceID:this.DeviceSelect.DeviceID,
                    Model:this.DeviceSelect.Model,
                    Password:this.DeviceSelect.Password,
                    SIMPhoneNum:this.DeviceSelect.SIMPhoneNum,
                    Serial:this.DeviceSelect.Serial,
                    Version:this.DeviceSelect.Version,
                    CurrentTime:timeNow,
                });
                
            },
            SearchIMEI(){
                this.TableFilter='';
                this.$store.commit('Device_GetInfoLikeIMEI',{
                    Key:this.TextSearchIMEI
                });
                this.DialogSearchIMEI=false;
            },
            Device_AdvancedSearch(){
                this.$store.commit('Device_AdvancedSearch',{
                    UserID:2188,
                    FleetName:this.AdvancedSearch.FleetName,
                    DriverName:this.AdvancedSearch.DriverName,
                    VehicleName:this.AdvancedSearch.VehicleName,
                    IMEI:this.AdvancedSearch.IMEI,
                    DeviceID:this.AdvancedSearch.DeviceID,
                    Version:this.AdvancedSearch.Version
                });
            },
            GetFleetsSearch(fleets,txt){
                var items=[];
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    if(fleet.FleetName.toLowerCase().includes(txt.toLowerCase())){
                        items.push(fleet)
                    }
                }
                return items;
            }
        }
    }
</script>

<style scoped>

</style>